import React, { useContext, useState } from "react";
import { Dropdown } from "react-bootstrap";
import Context from "../../../Context";

function HeaderLangButton() {
  const cx = useContext(Context);
  const [pending, setPending] = useState(false);
  const currentLang = cx.user.locale;

  const flagIcons = {
    ru: "/assets/media/svg/flags/013-russia.svg",
    en: "/assets/media/svg/flags/012-uk.svg",
  };

  const langToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div className="topbar-item">
      <div
        className="btn btn-icon btn-clean btn-dropdown btn-lg mr-1"
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        <img
          className="h-20px w-20px rounded-sm"
          src={flagIcons[currentLang]}
          alt=""
        />
      </div>
    </div>
  ));

  async function change(e, lang) {
    if (currentLang === lang) return;
    setPending(true);
    e.preventDefault();
    await cx.user.currentSet("locale", null, lang);

    document.location.reload();

    //Hack due to react-bootstrap dropdown issue #541
    document.dispatchEvent(new MouseEvent("click"));
  }

  if (pending || !currentLang) {
    return (
      <>
        <span className="spinner mr-10"></span>
      </>
    );
  }

  return (
    <Dropdown>
      <Dropdown.Toggle as={langToggle} id="langToggle" />
      <Dropdown.Menu
        popperConfig={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 10],
              },
            },
          ],
        }}
      >
        <ul className="navi navi-hover py-4">
          <li className="navi-item">
            <div
              onClick={(e) => change(e, "ru")}
              className="navi-link cursor-pointer"
            >
              <span className="symbol symbol-20 mr-3">
                <img src={flagIcons.ru} alt="" />
              </span>
              <span className="navi-text">Русский</span>
            </div>
          </li>
          <li className="navi-item">
            <div
              onClick={(e) => change(e, "en")}
              className="navi-link cursor-pointer"
            >
              <span className="symbol symbol-20 mr-3">
                <img src={flagIcons.en} alt="" />
              </span>
              <span className="navi-text">English</span>
            </div>
          </li>
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  );
}
export default HeaderLangButton;
